<template>
  <div class="home">
    <div class="row isSp">
      <div class="col-md-6 text-center">
        <button @click="$router.push('/howtouse')" class="bg-slate-500 text-white  font-bold uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 transition-all top-btn active:bg-slate-600" type="button"
      ><i class="far fa-question-circle"></i> 使い方</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 text-center">
        <button @click="$router.push('/category')" class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 transition-all top-btn" type="button"
      ><i class="fas fa-pen"></i> 論点別出題</button>
      </div>
      <div class="col-md-6 text-center">
        <button type="button" class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 transition-all top-btn" data-bs-toggle="modal" data-bs-target="#randamModal">
          <i class="fas fa-book-open"></i> 15問ランダム</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 text-center">
        <button @click="toWrong" class="bg-amber-500 text-white active:bg-amber-600 font-bold uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 transition-all top-btn" :disabled="!isAllow">
          <i class="fas fa-list"></i> 間違えた問題
        </button>
        <p class="text-danger" v-if="!isAllow">
          推奨ブラウザをご利用ください。
        </p>
      </div>
      <div class="col-md-6 text-center">
        <button @click="toBookmark" class="bg-amber-500 text-white active:bg-amber-600 font-bold uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 transition-all top-btn" :disabled="!isAllow">
          <i class="fas fa-bookmark"></i> ブックマーク
        </button>
      </div>
    </div>
    <div class="row isPc">
      <div class="col-md-6 text-center">
        <button @click="$router.push('/howtouse')" class="bg-slate-500 text-white  font-bold uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 transition-all top-btn active:bg-slate-600" type="button"
      ><i class="far fa-question-circle"></i> 使い方</button>
      </div>
      <div class="col-md-6 text-center">
      </div>
    </div>

    <div class="modal fade" id="randamModal" tabindex="-1" aria-labelledby="randomModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-2xl" id="randomModalLabel" style="font-weight: bold">15問ランダム出題</h5>
        <button id="modalClose" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>制限時間は15分です。<br>
すべての仕訳が終了してから「試験終了」を押下してください。</p>
      </div>
      <div class="modal-footer text-center" style="display:block">
        <button type="button" class="d-button bg-red-500 text-white active:bg-red-600 font-bold uppercase text px-4 py-2 rounded-full shadow-md hover:shadow-sm outline-none focus:outline-none transition-all" @click="random">試験開始</button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Emit } from "vue-property-decorator";
import HttpClient from "@/services/httpClient";
import BasicUtil from "@/services/basicUtil";
import StorageService from "../services/storage";

@Component({
  components: {},
})
export default class HomeView extends Vue {
  private dao: HttpClient = new HttpClient();
  private isAllow: boolean = BasicUtil.isAllow();
  private grade: number = Number(process.env.VUE_APP_GRADE)

  created() {
    const isAuth = BasicUtil.isAuth(this.grade)
    if (!isAuth) {
      location.href = "/auth"
      return
    }
  }

  mounted() {
    this.stopTimer();
    this.closePop();
    new BasicUtil().removeBasicSetting();
    if (this.$route.query.error == "back") {
      this.$toasted.show("ブラウザの「戻る」は使用しないでください", {
      duration: 2000,
      type: "error",
    });
    this.$router.push({query: { error: "" } });
    }
    
  }

  private random() {
    var modalClose = document.getElementById('modalClose')
    modalClose?.click();
    const datas = this.dao.getRandom15(this.grade);
    this.$store.commit("setType", 2);
    this.$store.commit("setQuestions", []);
    this.$store.commit("setQuestions", datas);
    new BasicUtil().setBasicSetting();
    this.startTimer();
    
    this.$router.push("/exam/1");
  }


  toWrong() {
    this.$router.push("/wrong");
  }

  toBookmark() {
    this.$router.push("/bookmark");
  }
  @Emit("startTimer")
  startTimer() {
    return;
  }

  @Emit("stopTimer")
  stopTimer() {
    return;
  }
  @Emit("closePop")
  closePop() {
    return;
  }
}
</script>
<style scoped>
.top-btn {
  display: inline-block;
  clear: both;
  min-height: 75px;
  text-align: center;
  width: 85%;
  min-width: 200px;
  padding-top: 1.5em !important;
  padding-bottom: 1.5em !important;
  margin: 2em auto;
  font-size: 1.2em;
}

.isSp {
  display: none;
}

.isPc {
  display: block;
}

@media screen and (max-width: 767px) {
.isSp {
  display: block;
}

.isPc {
  display: none;
}
}
</style>